import { PasswordStrength, commonPasswords, trigraphs } from 'tai-password-strength';
import { UserDto } from '../dtos/user';

enum PasswordStrengthCode {
    VERY_WEAK = "VERY_WEAK",
    WEAK = "WEAK",
    REASONABLE = "REASONABLE",
    STRONG = "STRONG",
    VERY_STRONG = "VERY_STRONG",
}

export class PasswordValidators {
    private user: UserDto;
    private pwdStrengthValidator = new PasswordStrength();

    constructor(user: UserDto) {
        this.user = user;

        this.pwdStrengthValidator.addCommonPasswords(commonPasswords);
        this.pwdStrengthValidator.addTrigraphMap(trigraphs);
    }

    public tooShort = (password = '') => password.length < 12;

    public isSameAsUserEmail = (password = ''): boolean => {
        return password.toLowerCase() === this.user?.email?.toLowerCase();
    };

    public isSameAsUserName = (password = ''): boolean => {
        return password.toLowerCase() === this.user?.name?.toLowerCase();
    }

    public isWeak = (password = ''): boolean => {
        const pwdCheck = this.pwdStrengthValidator.check(password);
        const strength = pwdCheck.strengthCode;

        return strength === PasswordStrengthCode.VERY_WEAK
            || strength === PasswordStrengthCode.WEAK
    }

    public score = (password = ''): string => {
        return this.readableScore(this.pwdStrengthValidator.check(password).strengthCode);
    }

    public readableScore = (strength = ''): string => {
          switch (strength) {
              case PasswordStrengthCode.VERY_STRONG:
                  return 'very strong';
              case PasswordStrengthCode.STRONG:
                  return 'strong';
              case PasswordStrengthCode.REASONABLE:
                  return 'medium';
              case PasswordStrengthCode.WEAK:
                  return 'weak';
              case PasswordStrengthCode.VERY_WEAK:
              default:
                  return 'very weak';
        }
    }

    public validate = (rule: any, value: any, callback: Function) => {
        value = value || '';
        const currentErrors: any[] = [];
        const errors: Array<{ condition: boolean, message: string }> = [
            {
                // tslint:disable-next-line:no-invalid-this
                condition: this.tooShort(value),
                message: 'Your password must be at least 7 characters',
            },
            {
                condition: this.isSameAsUserEmail(value),
                message: 'Passwords may not be the same as your email',
            },
            {
                condition: this.isSameAsUserName(value),
                message: 'Passwords may not be the same as your name',
            },
            {
                condition: this.isWeak(value),
                message: 'Your password must be stronger'
            }
        ];

        errors.some((err): boolean => {
            if (err.condition && value !== '') {
                currentErrors.push('Password does not meet requirements.');
                return true;
            }

            return false;
        });

        callback(currentErrors);
    };
}
